
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { AuthenticationService } from './authentication.service';
import { Baseservice } from './baseservice';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VehicleTypeService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('vehicle-type', http, authentication);
  }
  getPermitTypeVehicles(){
      
    return this.http.get(this.url+"/permit-type-vehicle/all");
}
getPermitTypeVehicle(id){
      
  return this.http.get(this.url+"/ptype/"+id);
}

loadvehicletypes(){    
return this.getRequest(this.url);
}

}
